import { render, staticRenderFns } from "./addOfficial.vue?vue&type=template&id=b1eadb38&"
import script from "./addOfficial.vue?vue&type=script&lang=js&"
export * from "./addOfficial.vue?vue&type=script&lang=js&"
import style0 from "./addOfficial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports